var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 16C123.451 16 16 123.451 16 256S123.451 496 256 496S496 388.549 496 256S388.549 16 256 16ZM432 256C432 286.035 424.404 314.318 411.084 339.082L288 240.615V83.059C369.799 98.166 432 169.895 432 256ZM224 428.941C192.639 423.15 164.221 409.039 141.031 388.959L224 322.584V428.941ZM288 322.584L370.969 388.959C347.779 409.039 319.361 423.15 288 428.941V322.584ZM224 83.059V240.615L100.916 339.082C87.596 314.318 80 286.035 80 256C80 169.895 142.201 98.166 224 83.059Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeace);
export default __webpack_public_path__ + "static/media/peace.fc84e0ed21e5dbda1280ffa48b04149b.svg";
export { ForwardRef as ReactComponent };